export default __webpack_public_path__ + "static/media/richDad.eff0e240.jpg";